<template>
  <requested-calendar />
</template>

<script>
import RequestedCalendar from "./requested_calendar/Index.vue";

export default {
  name: "TripRequestedCalendar",
  components: { RequestedCalendar },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
